import '../styles/WelcomeStyles.css'
export default function Welcome() {
    return (
        <div className='welcome__container'>
            <div className="welcome__intro-container">
                <div className="welcome__heading"> Zoe Lederman</div>
                <div className="welcome__tagline">
                    front-end developer
                    <br />focused on fabricating intuitive user interfaces<br />
                    fueled by a fervent curiousity to learn
                </div>
            </div>
        </div>


    )
}
